import { PAGE_LIST } from 'constant/pages';
import { createContext, useContext, useMemo } from 'react';
import { NavigateFunction } from 'react-router-dom';

type AuthContext = {
  login: (
    token: string,
    navigateDestination: string,
    navigate: NavigateFunction
  ) => Promise<void>;
  logout: (navigate: NavigateFunction) => void;
};

const AuthContext = createContext<AuthContext>({} as AuthContext);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const login = async (
    token: string,
    navigateDestination: string,
    navigate: NavigateFunction
  ) => {
    localStorage.setItem('accessToken', token);
    navigate(`${navigateDestination}?accessToken=${token}`);
  };

  const logout = (navigate: NavigateFunction) => {
    localStorage.removeItem('accessToken');
    navigate(`${PAGE_LIST.LOGIN.pathname()}?accessToken=null`, {
      replace: true,
    });
  };

  const value = useMemo(
    () => ({
      login,
      logout,
    }),
    []
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
